module.exports = __webpack_public_path__ + "static/media/remote_client.295adf8f.jpg";